import { Component, computed, inject, ChangeDetectionStrategy } from "@angular/core";
import { UtilityService } from "@eforall/common";
import { AppService, DomainDataService } from "../../../../../services";
import { AccApplicationDialogDataService } from "../../acc-application-dialog-data.service";

@Component({
	selector: 'acc-application-status-log-list-part',
	standalone: true,
	templateUrl: './status-log-list.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './status-log-list.part.scss'
})
export class StatusLogListPart {

	public accAppDialogDataService = inject(AccApplicationDialogDataService);
	private utils = inject(UtilityService);
	private domain = inject(DomainDataService);
	private app = inject(AppService);

	public readonly accApplicationStatusLogs = computed(() => {
		return this.accAppDialogDataService.dialogData()?.statusLogs.map((log) => ({
			...log,
			updatedUTC: this.utils.date.formatUTC(log.updatedUTC, 'MM/DD/YYYY', 'No Time', 'en-US'),
			icon: this.getStatusIcon(log.toAccApplicationStatusId),
			status: this.domain.data().accApplicationStatusesMap[log.toAccApplicationStatusId]?.name,
			displayName: log.updatedByStaffId ? this.app.getStaffNameById(log.updatedByStaffId) : log.updatedByPersonName
		}));
	});

	public getStatusIcon(statusId: number) {
		if (statusId == 1) return 'fa-fw fa-circle-info fa-solid text-secondary';
		else if (statusId == 3 || statusId == 4 || statusId == 5) return 'fa-fw fa-circle-xmark fa-solid text-danger';
		else if (statusId == 9) return 'fa-fw fa-circle-check fa-solid text-success';
		else return 'fa-fw fa-circle-info fa-solid text-info';
	}
}